var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderShare)?_c('share',{ref:"blockActionShare",attrs:{"url":_vm.blockAction ? _vm.blockAction.url : ''}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }